import type { BookingDetailsState } from '../../domain/types'
import { getIsCancelBookingActionShown } from './cancelBookingSelectors'

const MANAGE_BOOKING_DESCRIPTION_KEY = {
  cancel: 'booking_details_manage_booking_cancel_description',
  default: 'booking_details_manage_booking_description',
  delete: 'booking_details_manage_booking_delete_description',
  rebookAndCancel: 'booking_details_manage_booking_rebook_and_cancel_description',
}

export function getIsDeleteDialogOpen(state: BookingDetailsState): boolean {
  return state.isDeleteDialogOpen
}

export function getDeleteBookingRequestStatus(state: BookingDetailsState) {
  return state.deleteBookingRequestStatus
}

export function getIsDeleteBookingRequestLoading(state: BookingDetailsState): boolean {
  return state.deleteBookingRequestStatus === 'loading'
}

export function getIsDeleteBookingDialogLocked(state: BookingDetailsState): boolean {
  return state.deleteBookingRequestStatus === 'loading' || state.deleteBookingRequestStatus === 'success'
}

export function getIsDeleteBookingRequestError(state: BookingDetailsState): boolean {
  return state.deleteBookingRequestStatus === 'error'
}

export function getIsDeleteActionShown(state: BookingDetailsState): boolean {
  return state.canAccountBeDeleted && state.customerId !== null
}

export function getIsRebookActionShown(state: BookingDetailsState): boolean {
  return state.rebooking !== null
}

export function getCanRebookSameAccommodation(state: BookingDetailsState): boolean {
  return state.rebooking?.hasAccommodationAvailability ?? false
}

export function getSameAccommodationRebookingUrl(state: BookingDetailsState): string | null {
  return state.accommodations[0]?.url ?? null
}

export function getManageBookingDescriptionKey(
  state: BookingDetailsState,
  now: Date = new Date(),
): string {
  if (getIsDeleteActionShown(state)) {
    return MANAGE_BOOKING_DESCRIPTION_KEY.delete
  }

  const isCancelActionShown = getIsCancelBookingActionShown(state, now)

  if (getIsRebookActionShown(state) && isCancelActionShown) {
    return MANAGE_BOOKING_DESCRIPTION_KEY.rebookAndCancel
  }

  if (isCancelActionShown) {
    return MANAGE_BOOKING_DESCRIPTION_KEY.cancel
  }

  return MANAGE_BOOKING_DESCRIPTION_KEY.default
}

export function getIsManageBookingSectionShown(state: BookingDetailsState, now: Date = new Date()): boolean {
  return (
    getIsDeleteActionShown(state)
    || getIsRebookActionShown(state)
    || getIsCancelBookingActionShown(state, now)
  )
}
